import React, { Fragment, useEffect, useState } from 'react'
import Control from 'components/Control/Control'
import Label from 'components/Label/Label'
import Button from 'components/Button'
import {
  Heading,
  ImageUploadWrapper,
  ImageTag,
  StyledInput,
  StyledInputDiv,
  StyledSelectDiv,
  FormItem,
  ButtonWrap,
  AlterContent,
  NoteText,
  CenterText,
} from 'modules/Onboarding/Register/PersonalInfo/style'
import Camera from 'components/icons/Camera'
import AntdInput from 'components/Form/Input'
import AntdSelect from 'components/Form/Select'
import moment from 'moment'
import Date from 'components/Date/Date'
import Uploader from 'components/Uploader/Uploader'
import FileReader from 'components/Uploader/FileReader'
import {
  CountryCode,
  genderOptions,
} from 'modules/Onboarding/Register/PersonalInfo/Constant'
import { useDispatch, useSelector } from 'react-redux'
import { SendOtp, checkEmailOtp } from 'modules/ManageProfile/actions'
import Emptystates from 'components/icons/emptystates.svg'
import Party from 'components/images/party.png'
import { upsertStudentResume, getStudentResumeData } from "modules/Resume/actions"
import { Modal, Form } from 'antd'
import {
  RowPadding,
  StyledSpan,
  Content,
  MailHeading,
  MailSubHeading,
  DisplayPad,
  Learn,
  SplitFlex,
} from 'modules/ManageProfile/Style/style'
import {
  OtpDiv,
  OTPHeading,
  InputGroup,
  OTPButton,
  OTPMessage,
  SpanBold,
  Span,
} from 'modules/Onboarding/Components/ActivateAccount/CheckOtpPage/style'
import Flex from 'components/Flex'
import Input from 'components/Input/Input'
import Check from 'components/icons/CheckCircleIcon'
import Avatar from 'components/Avatar'
import { IsValidEmail } from 'utils/emailValidation'
import { Progress, Spin } from 'antd'
import ErrorMessage from 'utils/ErrorMessage'

const PersonalInfoForm = ({
  form,
  onChangeGender,
  gender,
  file,
  setFile,
  studentFormData,
  onCountryCodeChange,
  countryCode,
  onRemoveImage,
  onDateChange,
  studentData,
  error,
  setError,
  setGender,
  dob,
  updateCvDetails,
  getStudentData,
  updateStudentData,
  onStartCvUpload = () => {},
  onCvProgress = () => {},
  onFinishCvUpload = () => {},
  frozenFields = {},
}) => {
  const dispatch = new useDispatch()

  const [emailModel, setEmailModel] = useState(false)
  const [emailOTP, setEmailOTP] = useState(false)
  const [emailVerify, setEmailVerify] = useState(false)
  
  // CV state variables
  const [cvDetails, setCvDetails] = useState(studentData?.cvDetails || {})
  const [loadingCV, setLoadingCV] = useState(false)
  const [prevCvUrl, setPrevCvUrl] = useState(studentData?.cvUrl || '')
  const [progress, setProgress] = useState(0)
  const instituteName = useSelector(state => state?.studentData?.campusDetails)
  
  // Update prevCvUrl when studentData changes
  useEffect(() => {
    // Check if cvUrl is an empty object, missing required properties, or has valid value
    if (studentData?.cvUrl) {
      // Check for empty object or missing required properties (url, name, size)
      if (Object.keys(studentData?.cvUrl).length === 0 || (!studentData?.cvUrl?.url && !studentData?.cvUrl?.name)) {
        setPrevCvUrl('')
      } else {
        setPrevCvUrl(studentData?.cvUrl)
      }
    } else {
      setPrevCvUrl('')
    }
  }, [studentData?.cvUrl])

  // Update profileUrl state when studentData changes (e.g., after CV upload)
  useEffect(() => {
    if (studentData?.student?.profileUrl) {
      setFile(studentData?.student?.profileUrl)
    }
  }, [studentData?.student?.profileUrl])
  
  // Remove CV function
  const removeCv = () => {
    setCvDetails({})
    setPrevCvUrl('')
    setLoadingCV(false)
    
    // Update form data
    if (studentFormData?.student) {
      studentFormData.student.cvUrl = {}
    }
    form.setFieldsValue({
      'student.cvUrl': {}
    })
  }
  
  // Upload CV function
  const uploadCV = async (file, submit = true) => {
     // START
     onStartCvUpload() // inform parent to switch modals
     let isUpdated = false
     setLoadingCV(true)
     let allowResumeSave = true;
    try {
      const resumeResponse = await dispatch(getStudentResumeData())
      const existingResumes = resumeResponse?.resumes || []
      if (existingResumes.length >= 5) {
        allowResumeSave=false;
      }
      const updatedResumes = [
        ...existingResumes,
        {
          id: null,
          resumeName: file.name,
          resumeType: "UPLOADED",
          fileFormat: "pdf",
          fileUrl: { url: file.url },
          isDefault: false,
          fileSize: file.size
        }
      ]
      await dispatch(
        upsertStudentResume({
          checkForApproval: true,
          instituteCampusId: instituteName?.id,
          resumes: updatedResumes
        })
      )
    } catch (err) {
      console.error("Resume save failed", err)
    }
     if (!submit) {
       setCvDetails(file)
     }
     let cvData = studentData?.cvDetails
     // for service
     if (
       file &&
       submit &&
       (cvDetails?.url !== prevCvUrl ||
         (cvDetails?.url == prevCvUrl && cvData && !Object.keys(cvData)?.length))
     ) {
       const interval = setInterval(() => {
         onCvProgress(prevProgress => {
           const nextProgress = prevProgress + 10
           if (nextProgress >= 100) {
             clearInterval(interval)
             return 100
           }
           return nextProgress
         })
       }, 2000)
       isUpdated = await updateCvDetails(studentData?.id, {
         url: file?.url,
       })
       if (isUpdated) {
         getStudentData()
         onCvProgress(90)
         //   setLoadingCV(false)
         setPrevCvUrl(file)
         setTimeout(() => {
           //  setCurrent(activeKey + 1)
         }, 2000)
       } else {
         setLoadingCV(false)
         onCvProgress(0)
         ErrorMessage('Failed to parse this CV !')
       }
     } else if (submit) {
       setLoadingCV(false)
       setTimeout(() => {
         // setCurrent(activeKey + 1)
       }, 1000)
     }
 
     if (submit) {
       if (!studentFormData?.admin?.dob) delete studentFormData?.admin?.dob
       if (!studentFormData?.admin?.gender) delete studentFormData?.admin?.gender
       if (!studentFormData?.studentPersonalProfile?.permPostCode)
         delete studentFormData?.studentPersonalProfile?.permPostCode
       if (!studentFormData?.studentPersonalProfile?.corrPostCode)
         delete studentFormData?.studentPersonalProfile?.corrPostCode
       if (!studentFormData?.studentPersonalProfile?.secondaryEmail)
         delete studentFormData?.studentPersonalProfile?.secondaryEmail
       let payload = {
         admin: {
           ...studentFormData.admin,
         },
         student: {
           ...studentFormData.student,
           profileUrl:
             form.getFieldValue('profileUrl') ||
             studentFormData?.student?.profileUrl ||
             undefined,
           cvUrl: file ?? {},
         },
         studentPersonalProfile: {
           ...studentFormData?.studentPersonalProfile,
         },
         currentCourse: !studentFormData?.student?.isExpCandidate
           ? {
               ...studentFormData?.currentCourse,
               skills:
                 studentFormData?.currentCourse?.skills == null
                   ? []
                   : studentFormData?.currentCourse?.skills,
             }
           : {},
         degreeStreamMap: !studentFormData?.student?.isExpCandidate
           ? {
               degreeId: studentFormData?.currentCourse?.degreeId,
               streamId: studentFormData?.currentCourse?.streamId,
             }
           : {},
 
         education: studentFormData?.education,
         resume: studentFormData?.resume,
       }
       if (payload?.currentCourse?.degreeStreamMapId === null) {
         delete payload?.currentCourse?.degreeStreamMapId
       }
       studentFormData?.education?.map((item, index) => {
         if (item?.skills === null) delete payload?.education[index]?.skills
         if (item?.markSheetUrl === null)
           delete payload?.education[index]?.markSheetUrl
         if (item?.degreeStreamMapId === null)
           delete payload?.education[index]?.degreeStreamMapId
       })
 
       let response = await updateStudentData(payload)
       if (response?.success === true) {
       //  setLoading(false)
         getStudentData()
         onCvProgress(100)
         setLoadingCV(false)
         onFinishCvUpload() // inform parent to switch modals
       } else {
      //   setLoading(false)
         onCvProgress(100)
         setLoadingCV(false)
         onFinishCvUpload() // inform parent to switch modals
         ErrorMessage(
           response?.response?.data?.message ?? 'Something went wrong'
         )
       }
     }
   }
  const [otpEmail, setOtpEmail] = useState({
    otp1: '',
    otp2: '',
    otp3: '',
    otp4: '',
  })
  const [enteredEmail, setEnteredEmail] = useState('')
  const [errmsg, setErrmsg] = useState(null)
  useEffect(() => {
    if (otpEmail?.otp1 && otpEmail?.otp2 && otpEmail?.otp3 && otpEmail?.otp4) {
      otpEmailCheck()
    }
  }, [otpEmail])


  const clickEventEmail = (position, e) => {
    if (position !== 'last' && e.target.value) {
      document.getElementById(position).focus()
    }
    if (position === 'sec') {
      setOtpEmail({ ...otpEmail, otp1: e.target.value })
    } else if (position === 'third') {
      setOtpEmail({ ...otpEmail, otp2: e.target.value })
    } else if (position === 'fourth') {
      setOtpEmail({ ...otpEmail, otp3: e.target.value })
    } else {
      setOtpEmail({ ...otpEmail, otp4: e.target.value })
    }
  }
  const emailOTPKeyDown = (position, e) => {
    if (e.keyCode === 8 && position !== '1st') {
      // Backspace key is pressed and it's not the first input field
      const prevPositionNumber = getPrevPositionNumber(position)
      const prevPosition = getPrevPosition(position)
      if (position == 'fourth' && otpEmail.otp4) {
        setOtpEmail(prevOtp => ({
          ...prevOtp,
          ['otp4']: '',
        }))
      } else {
        document.getElementById(prevPosition).focus()
        setOtpEmail(prevOtp => ({
          ...prevOtp,
          ['otp' + prevPositionNumber]: '',
          ['otp' + (prevPositionNumber + 1)]: '',
        }))
      }
    }
  }

  const getPrevPositionNumber = currentPosition => {
    switch (currentPosition) {
      case 'sec':
        return 1
      case 'third':
        return 2
      case 'fourth':
        return 3
      default:
        return 0
    }
  }
  const getPrevPosition = currentPosition => {
    switch (currentPosition) {
      case 'sec':
        return '1st'
      case 'third':
        return 'sec'
      case 'fourth':
        return 'third'
      default:
        return ''
    }
  }

  const changeMail = () => {
    setEmailModel(true)
  }

  const handleEmailCancel = () => {
    setEmailModel(false)
    setEnteredEmail('')
  }
  const handleEmailOTPCancel = () => {
    setEmailOTP(false)
    setEnteredEmail('')

    setOtpEmail({
      otp1: '',
      otp2: '',
      otp3: '',
      otp4: '',
    })
  }
  const handleEmailVerifyCancel = () => {
    setEmailVerify(false)
    setEnteredEmail('')
    setOtpEmail({
      otp1: '',
      otp2: '',
      otp3: '',
      otp4: '',
    })
  }

  const onEmailEntered = e => {
    setEnteredEmail(e.target.value)
  }

  const sendEmailOTP = async values => {
    let payLoad = {
      newEmail: enteredEmail,
      newPhone: '',
    }
    let callBack = msg => {
      if (msg == 'success') {
        setEmailModel(false)
        setEmailOTP(true)
      }
    }
    dispatch(SendOtp(studentData?.admin?._id, payLoad, callBack))
  }

  const otpEmailCheck = async () => {
    let otpNum = `${otpEmail?.otp1}${otpEmail?.otp2}${otpEmail?.otp3}${otpEmail?.otp4}`
    let payLoad = {
      otp: otpNum,
      newEmail: enteredEmail,
    }
    let response = await dispatch(
      checkEmailOtp(studentData?.admin?._id, payLoad)
    )

    if (response?.data?.message?.success === true) {
      form.setFieldsValue({
        email: enteredEmail,
      })
      setEmailVerify(true)
      setEmailOTP(false)
      setErrmsg(null)
    } else {
      setErrmsg('Incorrect OTP')
    }
  }

  const validatePhoneNumber = (rule, value, callback) => {
    // Check if the value contains any alphabets
    if (/[a-zA-Z]/.test(value)) {
      callback('Phone number cannot contain alphabets!')
    } else {
      callback()
    }
  }

  return (
    <Fragment>
      {/* <Control flexStart row width="100%" spaceBetween>
        <Control flexStart width="70%" column>
          <Control gap="15px" flexStart>
            <Control column flexStart>
              <Label>First Name *</Label>
              <AntdInput
                placeholder="First name"
                name={'firstName'}
                maxLength={120}
                rules={[
                  {
                    required: true,
                    min: 3,
                    max: 120,
                    message:
                      'Please enter your name! Minimum 3 characters , Maximum 120 characters',
                  },
                ]}
              />
            </Control>
            <Control column flexStart>
              <Label>Last Name</Label>
              <AntdInput
                placeholder="Last name"
                name={'lastName'}
                maxLength={60}
              />
            </Control>
          </Control>

          <Control flexStart top="35px" column>
            <Label>Registration No </Label>
            <AntdInput
              placeholder="Enter your registration no"
              name={'uniRollNo'}
              rules={[
                {
                  min: 3,
                  max: 120,
                  message:
                    'Please enter Registration Number! Minimum 3 characters , Maximum 120 characters',
                },
              ]}
            />
          </Control>
          {studentFormData?.admin?.firstName && (
            <>
              <FormItem
                name={'dob'}
                rules={[
                  {
                    required: true,
                    message: 'Please enter a date of birth',
                  },
                ]}
              >
                <Control flexStart top="35px" column>
                  <Label>Date of birth *</Label>
                  <Date
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    value={dob ? moment(dob) : null}
                    onChange={onDateChange}
                    disabledDate={d => !d || d.isAfter(moment())}
                    inputReadOnly
                  />
                </Control>
              </FormItem>
              {error && <p style={{ color: 'red' }}>{error}</p>}
            </>
          )}
          <Control flexStart top="35px" column>
            <FormItem name={'gender'} padding={true}>
              <div></div>
            </FormItem>
            <Label>Gender *</Label>

            <AntdSelect
              placeholder="Select"
              OptionData={genderOptions}
              name={'gender'}
              rules={[
                {
                  validator: async (_, value) => {
                    if (!gender) {
                      return Promise.reject(new Error('Please select a gender!'))
                    }
                    return Promise.resolve()
                  },
                },
              ]}
              onChange={onChangeGender}
              valueParam="value"
              nameParam="name"
              value={gender}
              showSearch={true}
            />
          </Control>
        </Control>

        <Control column alignCenter width="200px" center>
          <ImageUploadWrapper column alignCenter center boarder={!file}>
            {!file && (
              <Fragment>
                <Control column alignCenter>
                  <Camera />
                </Control>
                <Control column alignCenter top={'3px'}>
                  <Control column alignCenter>
                    Max file size: 2MB
                  </Control>
                  <Control column alignCenter>
                    Dimension: 130*130
                  </Control>
                  <Control column alignCenter>
                    File format: .png, .jpeg
                  </Control>
                </Control>
              </Fragment>
            )}
            {file && <ImageTag src={file} />}
          </ImageUploadWrapper>
          {!file && (
            <>
              <Control alignCenter center>
                <Uploader
                  setFile={setFile}
                  showTextUploder={!file}
                  fileName={
                    studentFormData?.admin?.firstName
                      ?.toLowerCase()
                      .replace(/\s/g, '') + '_profile'
                  }
                />
              </Control>
              <CenterText>
                <NoteText>Note:</NoteText>
                <NoteText>Max file size: 2MB</NoteText>
                <NoteText>Dimension: 130*130</NoteText>
                <NoteText>File format: .png, .jpeg</NoteText>
              </CenterText>
            </>
          )}
          <FormItem
            name={'profileUrl'}
            padding={true}
            rules={[
              {
                required: true,
                message: 'Please Upload Image!',
              },
            ]}
          >
            <div></div>
          </FormItem>
          {file ? (
            <ButtonWrap>
              <Control
                width="100%"
                flexEnd
                gap="10px"
                top="15px"
                column
                alignCenter
              >
                <Button.Secondary
                  text="Remove"
                  onClick={onRemoveImage}
                  height={'32px'}
                />
                <Uploader
                  isDelete={true}
                  file={file}
                  setFile={setFile}
                  showButtonUploder={!!file}
                  fileName={
                    studentFormData?.admin?.firstName
                      ?.toLowerCase()
                      .replace(/\s/g, '') + '_profile'
                  }
                />
              </Control>
            </ButtonWrap>
          ) : null}
        </Control>
      </Control> */}
       <Control bottom="20px">
        <Heading>Personal Details</Heading>
      </Control>
      <Label>Profile Picture</Label>
<Control top="10px" bottom="10px">

<Control column alignCenter width="200px" center>
          <ImageUploadWrapper column alignCenter center boarder={!file}>
            {!file && (
              <Fragment>
                <Control column alignCenter>
                  <Camera />
                </Control>
                <Control column alignCenter top={'3px'}>
                  <Control column alignCenter>
                    Max file size: 2MB
                  </Control>
                  <Control column alignCenter>
                    Dimension: 130*130
                  </Control>
                  <Control column alignCenter>
                    File format: .png, .jpeg
                  </Control>
                </Control>
              </Fragment>
            )}
            {file && <ImageTag src={file} />}
          </ImageUploadWrapper>
          {!file && (
            <>
              <Control alignCenter center>
                <Uploader
                  setFile={setFile}
                  showTextUploder={!file}
                  fileName={
                    studentFormData?.admin?.firstName
                      ?.toLowerCase()
                      .replace(/\s/g, '') + '_profile'
                  }
                />
              </Control>
              {/* <CenterText>
                <NoteText>Note:</NoteText>
                <NoteText>Max file size: 2MB</NoteText>
                <NoteText>Dimension: 130*130</NoteText>
                <NoteText>File format: .png, .jpeg</NoteText>
              </CenterText> */}
            </>
          )}
          <FormItem
            name={'profileUrl'}
            padding={true}
           
          >
            <div></div>
          </FormItem>
          {file ? (
            <ButtonWrap>
              <Control
                width="100%"
                flexEnd
                gap="10px"
                top="15px"
                column
                alignCenter
              >
                <Button.Secondary
                  text="Remove"
                  onClick={() => {
                    setFile(null)
                    form.setFieldsValue({
                      profileUrl: '',
                    })
                  }}
                  height={'32px'}
                />
                <Uploader
                  isDelete={true}
                  file={file}
                  setFile={setFile}
                  showButtonUploder={!!file}
                  fileName={
                    studentFormData?.admin?.firstName
                      ?.toLowerCase()
                      .replace(/\s/g, '') + '_profile'
                  }
                />
              </Control>
            </ButtonWrap>
          ) : null}
        </Control>
</Control>

{/* CV Upload Section */}
<Label >Upload CV</Label>
      <Control top="5px" row>
        
        <Control column top="10px">
          {loadingCV ? (
            !progress || progress === 100 ? (
              <Spin />
            ) : (
              <Control center>
                <Progress percent={progress} type="circle" />
              </Control>
            )
          ) : (
            <>
              {prevCvUrl ? (
                <Control column top="10px" center>
                  <FileReader
                    file={{
                      ...prevCvUrl,
                      name:
                        studentFormData?.admin?.firstName
                          ?.toLowerCase()
                          ?.replace(/\s/g, '') +
                        ' ' +
                        studentFormData?.admin?.lastName
                          ?.toLowerCase()
                          ?.replace(/\s/g, '') +
                        '_CV',
                    }}
                    setFile={removeCv}
                    isView
                    fileName={
                      studentFormData?.admin?.firstName
                        ?.toLowerCase()
                        ?.replace(/\s/g, '') +
                      studentFormData?.admin?.lastName
                        ?.toLowerCase()
                        ?.replace(/\s/g, '') +
                      '_CV'
                    }
                  />
                </Control>
              ) : (
                <Control column top="10px" center>
                  <Uploader
                    width="100%"
                    height="190px"
                    isDefault={true}
                    fileName={
                      studentFormData?.admin?.firstName
                        ?.toLowerCase()
                        ?.replace(/\s/g, '') +
                      studentFormData?.admin?.lastName
                        ?.toLowerCase()
                        ?.replace(/\s/g, '') +
                      '_CV'
                    }
                    isCV={true}
                    onlyDoc={true}
                    setFile={uploadCV}
                  />
                </Control>
              )}
            </>
          )}
        </Control>
      </Control>

     
<Control top="25px">

<Control gap="15px" flexStart>
            <Control column flexStart>
              <Label>First Name *</Label>
              <AntdInput
                placeholder="First name"
                name={'firstName'}
                maxLength={120}
                disabled={frozenFields?.firstName}
                rules={[
                  {
                    required: true,
                    min: 3,
                    max: 120,
                    message:
                      'Please enter your name! Minimum 3 characters , Maximum 120 characters',
                  },
                ]}
              />
            </Control>
            <Control column flexStart>
              <Label>Last Name</Label>
              <AntdInput
                placeholder="Last name"
                name={'lastName'}
                maxLength={60}
                disabled={frozenFields?.lastName}
              />
            </Control>
          </Control>
</Control>
<Control>
<Control flexStart top="10px"  width="49%" column>
            <FormItem name={'gender'} padding={true}>
              <div></div>
            </FormItem>
            <Label>Gender *</Label>

            <AntdSelect
              placeholder="Select"
              OptionData={genderOptions}
              name={'gender'}
              disabled={frozenFields?.gender}
              rules={[
                {
                  validator: async (_, value) => {
                    if (!gender) {
                      return Promise.reject(new Error('Please select a gender!'))
                    }
                    return Promise.resolve()
                  },
                },
              ]}
              onChange={onChangeGender}
              valueParam="value"
              nameParam="name"
              value={gender}
              showSearch={true}
            />
          </Control>
        </Control>
<Control top="10px" gap="15px">
<Control  flexStart  column>
            <Label>Institute Roll Number </Label>
            <AntdInput
              placeholder="Enter your Institute Roll Number"
              name={'uniRollNo'}
              // rules={[
              //   {
              //     min: 3,
              //     max: 120,
              //     message:
              //       'Please enter Registration Number! Minimum 3 characters , Maximum 120 characters',
              //   },
              // ]}
            />
          </Control>
          {/* {studentFormData?.admin?.firstName && ( */}
            <>
              <FormItem
                name={'dob'}
                rules={[
                  {
                    required: true,
                    message: 'Please enter a date of birth',
                  },
                ]}
              >
                <Control column>
                  <Label>Date of birth *</Label>
                  <Date
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    value={dob ? moment(dob) : null}
                    onChange={onDateChange}
                    disabledDate={d => !d || d.isAfter(moment())}
                    inputReadOnly
                    disabled={frozenFields?.dob}
                  />
                </Control>
              </FormItem>
              {error && <p style={{ color: 'red' }}>{error}</p>}
            </>
          {/* )} */}
</Control>
<Control top="25px">
        <Heading>Contact Details</Heading>
      </Control>
      <Control top="25px"  gap="15px">
      <Control flexStart column>
        <Label>Primary Email Address *</Label>
        <AntdInput
          placeholder="eg:harry@yahoo.com"
          name={'email'}
          rules={[
            {
              required: true,
              message: 'Please enter primary email!',
            },
          ]}
          disabled={true}
      //    suffix={<StyledSpan onClick={changeMail}>Change</StyledSpan>}
        />
      </Control>
     
      <Control  column>
        <Label>Secondary Email Address</Label>
        <AntdInput
          placeholder="eg:harry@yahoo.com"
          name={'secondaryEmail'}
          rules={[
            {
              required: false,
            },
            () => ({
              validator(_, value) {
                let isValid = IsValidEmail(value)
                if (!isValid) {
                  if (value === undefined || value === '' || value == null) {
                    return Promise.resolve()
                  } else {
                    return Promise.reject(new Error(`Please Enter Valid Email`))
                  }
                }

                return Promise.resolve()
              },
            }),
          ]}
        />
      </Control>
      </Control>
      <Control flexStart top="25px" width="49%" column>
        <Label>Phone No *</Label>
        <Control>
          <StyledSelectDiv>
            <AntdSelect
              width="100%"
              OptionData={CountryCode}
              nameParam="value"
              bordered={false}
              placeholder="+91"
              onChange={onCountryCodeChange}
              value={countryCode}
              disabled={true}
            />
          </StyledSelectDiv>
          <StyledInputDiv>
            <StyledInput
              width="100%"
              placeholder="Eg: 1010101010"
              disabled={frozenFields?.phoneNumber}
              rules={[
                {
                  required: true,
                  min: 10,
                  max: 10,
                  message: 'Please Enter a valid phone number!',
                },
                {
                  validator: validatePhoneNumber,
                },
              ]}
              name={'phoneNumber'}
            />
          </StyledInputDiv>
        </Control>
      </Control>
      {emailModel && (
        <Modal
          width={'585px'}
          open={emailModel}
          footer={null}
          onCancel={handleEmailCancel}
        >
          <RowPadding>
            <Content alignCenter column center>
              <Flex>
                <img src={Emptystates} alt='EmptyState' />
              </Flex>
              <MailHeading>Update Your Email ID</MailHeading>
              <MailSubHeading>
                You have to <b>Verify</b> your email ID to Login further
              </MailSubHeading>
            </Content>
            <Form
              style={{ width: '100%' }}
              scrollToFirstError
              onFinish={sendEmailOTP}
              id={'emailForm'}
              layout="vertical"
            >
              <Label>Email Address *</Label>
              <AntdInput
                AntdInput
                placeholder="eg:harry@yahoo.com"
                width="100%"
                name="Email"
                onChange={onEmailEntered}
                rules={[
                  () => ({
                    validator(_, value) {
                      let isValid = IsValidEmail(value)
                      if (!isValid) {
                        return Promise.reject(
                          new Error(`Please Enter Valid Email`)
                        )
                      }

                      return Promise.resolve()
                    },
                  }),
                ]}
              />

              <DisplayPad>
                <Button.Primary
                  htmlType="submit"
                  text={'Send Verification Code'}
                  width={'100%'}
                  padding={'10px'}
                />
              </DisplayPad>
            </Form>
            <MailSubHeading>
              You will recieve an OTP in your mail account to verify your email
              address.{' '}
            </MailSubHeading>

            <SplitFlex row spaceBetween alignCenter>
              <Flex flexStart>
                <Learn href={'http://pluginlive.com'} target="_blank">
                  Learn More
                </Learn>
              </Flex>
              <MailSubHeading>*Terms and condition applied</MailSubHeading>
            </SplitFlex>
          </RowPadding>
        </Modal>
      )}
      {emailOTP && (
        <Modal
          width={'585px'}
          open={emailOTP}
          footer={null}
          onCancel={handleEmailOTPCancel}
        >
          <RowPadding>
            <Content alignCenter column center>
              <Flex>
                <img src={Emptystates} alt='emptyState'/>
              </Flex>
              <MailHeading>Verify your Email Address </MailHeading>
            </Content>

            <MailSubHeading>
              We will send you a 4-digit ‘One Time Password’ to your email
              address . Please verify to proceed further.
            </MailSubHeading>
            <DisplayPad>
              <MailSubHeading>
                A verification code will be sent to <b>{enteredEmail}</b>
              </MailSubHeading>
            </DisplayPad>
            <OtpDiv alignCenter column>
              <OTPHeading>Enter the OTP</OTPHeading>
              <InputGroup>
                <Input
                  placeholder="0"
                  width="50px"
                  type="number"
                  id="1st"
                  maxLength={1}
                  onChange={e => clickEventEmail('sec', e)}
                  onKeyDown={e => emailOTPKeyDown('1st', e)}
                  value={otpEmail?.otp1}
                />
                <Input
                  placeholder="0"
                  type="number"
                  id="sec"
                  width="50px"
                  maxLength={1}
                  onChange={e => clickEventEmail('third', e)}
                  onKeyDown={e => emailOTPKeyDown('sec', e)}
                  value={otpEmail?.otp2}
                />
                <Input
                  placeholder="0"
                  width="50px"
                  type="number"
                  id="third"
                  maxLength={1}
                  onChange={e => clickEventEmail('fourth', e)}
                  onKeyDown={e => emailOTPKeyDown('third', e)}
                  value={otpEmail?.otp3}
                />
                <Input
                  placeholder="0"
                  id="fourth"
                  width="50px"
                  type="number"
                  maxLength={1}
                  onChange={e => clickEventEmail('last', e)}
                  onKeyDown={e => emailOTPKeyDown('fourth', e)}
                  value={otpEmail?.otp4}
                />
              </InputGroup>
              <Span>{errmsg}</Span>
              <OTPButton onClick={() => sendEmailOTP()}>
                Didn’t receive? &nbsp;<SpanBold>Resend OTP</SpanBold>
              </OTPButton>
              {!otpEmail?.otp4 && (
                <OTPMessage>
                  <div>
                    <Avatar size={20} src={<Check />} />
                  </div>
                  <div>OTP Sent Successfully.</div>
                </OTPMessage>
              )}
            </OtpDiv>
          </RowPadding>
        </Modal>
      )}
      {emailVerify && (
        <Modal
          width={'585px'}
          open={emailVerify}
          footer={null}
          onCancel={handleEmailVerifyCancel}
        >
          <RowPadding>
            <Content alignCenter column center>
              <Flex>
                <img src={Party}alt='party' />
              </Flex>
              <MailHeading>Verified Successfully</MailHeading>
              <MailSubHeading>
                Your Email address verified successfully
              </MailSubHeading>
            </Content>
          </RowPadding>
        </Modal>
      )}
    </Fragment>
  )
}

export default React.memo(PersonalInfoForm)
